<template>
  <div class="brand">
    <div class="brand-nav">
      <div class="home-news">
        <img class="service-img" src="../assets/black-logo.png">
        <div class="home-title">品牌理念</div>
        <div class="news-nav">
          <div class="news-information">
           <p style="margin-bottom: 1rem;">“我创立布瑞琳（BRANEW）的初衷，就是源于对高尚生活品质的追求。”——创始人寄语</p>
            <p>【品牌理念】：布瑞琳，用“新”改变生活</p>
            <p>布瑞琳（BRANEW）认为，每次太阳升起的时候，都是一个崭新生活的开始，人们眷恋过去的时光，期待未来的日子，更需要品味当下的生活。</p>
            生活源于细节，而布瑞琳人关注的就是生活的每一个细节，从柳钉到拉链，关注客户每一项需求，为客户提供贴心的清洗、养护服务。客户需要的，就是布瑞琳人关心的。我们深知只有用心，才能把每一项服务做到完美；只有贴心，才能为客户的优质生活提供保障。
          </div>
          <div class="news-information">
            <img src="../assets/brand-concept.jpg" alt="">
          </div>
        </div>
        <img class="service-img" src="../assets/black-logo.png">
        <div class="home-title">您的衣物洗护专家</div>
        <div class="wash-protect-nav">
          <div class="wash-protect-img">
            <img src="../assets/wash-protect.png" alt="">
          </div>
          <div class="wash-protect-introduction">
            <ul>
              <li>
                <span>终端品控的经营模式</span>
                直营连锁门店+中央洗护工厂模式，统一品牌形象，统一洗护标准，统一质量管理，统一物流配送，标准服务体系，保证洗护质量与客户体验。
              </li>
              <el-divider></el-divider>
              <li>
                <span>产品高端定制</span>
                专注高端产品洗护，根据目标客户的需求和分布，仅在高级购物中心、涉外公寓及使馆区、高端公寓等商圈开设门店，会员卡门店通用，提供标准洗护、定制洗护服务。
              </li>
              <el-divider></el-divider>
              <li>
                <span>一流的中央洗护工厂</span>
                采用国际洗护标准，国际一流洗护设备，洗涤助剂和洗护理念，开发和制定不同面料和织物风格的洗护工艺，标准化系统化的洗护流程，关注并严格执行每一道工序。
              </li>
              <el-divider></el-divider>
              <li>
                <span>专业的技术团队</span>
                团队出自六大纺织院校硕士研究生和学士生，持有国际专业干洗和水洗认证证书，国际干水洗研究协会成员，干洗采用美国纺织化学师与印染师AATCC158-2005标准。
              </li>
              <el-divider></el-divider>
              <li>
                <span>标准化的服务团队</span>
                拥有了解服装、洗染、服装品牌知识的专业人才，依托直营连锁模式，统一门店形象，员工形象，标准化服务流程，提供管家式服务，带给客户整体化洗护体验。
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
    <div class="brand-swiper">
      <div class="home-title">荣誉资质</div>
      <div class="brand-swiper-nav">
        <div class="partnerSwiper">
          <swiper :options="swiperOption" ref="mySwiper">
            <swiper-slide v-for="(item,index) in aboutBrandLists" :key="index">
              <el-image class="brand-icons" :src="'https://branew-pic.oss-cn-beijing.aliyuncs.com/' + item.thumbnail" :preview-src-list="['https://branew-pic.oss-cn-beijing.aliyuncs.com/' + item.thumbnail]"></el-image>
              <!-- <img class="brand-icons" :src="item.img" alt="" @click="lookMaxImg(item)"> -->
            </swiper-slide>

            <!-- <div class="swiper-pagination"  slot="pagination"></div> -->
            <div class="swiper-button-prev" slot="button-prev"></div>
            <div  class="swiper-button-next" slot="button-next"></div>
          </swiper>
        </div>
      </div>
    </div>

    <el-dialog
      :visible.sync="dialogVisible"
      width="40%"
      :before-close="handleClose">
      <img style="width:100%;" :src="srcList" alt="">
    </el-dialog>
    
  </div>
</template>

<script>
import HelloWorld from '@/components/HelloWorld.vue';

export default {
  name: 'Home',
  components: {
    HelloWorld,
  },
  data(){
    return {
      // list:[
      //   {img: require('../assets/logo.png')},
      //   {img: require('../assets/logo.png')},
      //   {img: require('../assets/logo.png')}
      // ],
      swiperOption: {
        slidesPerView: 5,
        spaceBetween: 30,
        slidesPerGroup: 1,
        // loop: true,
        loopFillGroupWithBlank: true,
        // notNextTick: true,
        // 如果需要自动播放
        // autoplay : {
        //   delay:3000,
        //   disableOnInteraction:false,  //用户操作swiper之后，是否禁止autoplay。
        // },
        navigation: {
          nextEl: '.swiper-button-next', //前进按钮的css选择器或HTML元素。
          prevEl: '.swiper-button-prev', //后退按钮的css选择器或HTML元素。
          hideOnClick: true, //点击slide时显示/隐藏按钮
        },
      },
      aboutBrandLists:[],
      brandLists: [
        {
          title:'123',
          img: require('@/assets/brand-icon1.png')
        },{
          title:'123',
          img: require('@/assets/brand-icon2.jpg')
        },{
          title:'123',
          img: require('@/assets/brand-icon3.jpg')
        },{
          title:'123',
          img: require('@/assets/brand-icon4.jpg')
        },{
          title:'123',
          img: require('@/assets/brand-icon6.jpg')
        },{
          title:'123',
          img: require('@/assets/brand-icon7.jpg')
        },{
          title:'123',
          img: require('@/assets/brand-icon8.jpg')
        },{
          title:'123',
          img: require('@/assets/brand-icon9.jpg')
        },{
          title:'123',
          img: require('@/assets/brand-icon10.jpg')
        },{
          title:'123',
          img: require('@/assets/brand-icon11.png')
        }
      ],
      srcList:"",
      dialogVisible: false,
    }
  },
  mounted(){
  },
  created() {
    console.log('首页进入接口');

    this.$fetch("store/select/contentColumn").then(res => {
      console.log(res);
      res.map(item => {
        if(item.name == "荣誉资质"){
          this.$fetch("store/select/contentArticle",{from: 0, size: 20, id: item.id}).then(result => {
            console.log("store/select/contentArticle", result);
            this.aboutBrandLists = result.items;
          })
        }
      })
    })
  },
  methods:{
    lookMaxImg(item,index){
      console.log('1111111111',item);
      this.dialogVisible = true;
      this.srcList = item.img;
    },
    handleClose(done) {
      done();
    },
  },
  
}
</script>
<style scoped lang="scss">
.home{
    width: 100%;
    background: #F3F5FA;
    overflow: hidden;
}
.home-img{
  width: 100%;
  height: 47rem;
}
.brand-nav{
  padding: 0 12rem;
}
.service-img{
  width: 1.5rem;
  height: 1.7rem;
  margin-top: 4rem;
}
.home-title{
  font-size: 2rem;
  margin: 1rem 0 3rem;
}
.home-paper{
  font-size: 1rem;
  margin-bottom: 3rem;
}

.wash-protect-nav{
  position: relative;
  // height: 52rem;
  overflow: hidden;

  .wash-protect-img{
    // width: 44.9rem;
    // height: 31.4rem;
    width: 47%;
    height: 85%;
    position: absolute;
    left: 0;
    top: 50%;
    transform: translateY(-50%);
    z-index: 2;

    img{
      width: 100%;
      height: 100%;
    }
  }

  .wash-protect-introduction{
    padding: 0 5rem;
    background: #AFBECD;
    color: #fff;
    // width: 80rem;
    width: 80%;
    height: 100%;
    float: right;
    z-index: 1;

    ul{
      list-style-type: none;
      padding: 1rem 0;
      // width: 41rem;
      width: 62%;
      float: right;
      text-align: left;

      li{
        padding: 2rem 0 2.5rem;
        // border-bottom: 1px solid #fff;

        span{
          display: block;
          font-size: 1.2rem;
          margin-bottom: 0.7rem;
        }
      }
    }
  }
}

.news-nav{
  display: flex;
  justify-content: space-between;
  margin-bottom: 2rem;

  .news-information{
    width: 45.5rem;
    text-align: left;

    img{
      width: 100%;
      height: 28.2rem;
    }

    .news-title{
      font-size: 1rem;
      margin: 1rem 0;
    }
    .news-time{
      font-size: 1rem;
      color: #999;
    }
  }
}

.brand-swiper{
  background: #fff;
  padding: 3rem 12rem;

  .brand-swiper-nav{
    position: relative;
    width: 104%;
    margin-left: -2%;
  }

  .partnerSwiper{
    overflow: hidden;
    padding: 3rem 1rem;

    .swiper-slide{
      // border: 1px solid #aaa;
      padding: 1rem;
      overflow: hidden;
      box-shadow: 0 1px 8px 1px #ced5de;
      height: 17rem;
    }

    .swiper-button-prev{
      left: -3rem;
      color: #aaa;
    }
    .swiper-button-next{
      right: -3rem;
      color: #aaa;
    }
  }
}

::v-deep .el-divider--horizontal{
  margin: 0;
  color: #fff;
}

.brand-icons{
  // width: 100%;
  // height: 15rem;
  // cursor: pointer;
  height: 100%;
}

::v-deep .el-dialog{
  background: none;
  box-shadow:none;
}
::v-deep .el-dialog__headerbtn .el-dialog__close{
  color: #fff;
  font-size: 2rem;
}

</style>